/**
 * Shared helper to read the user's currently selected language and attach it
 * as the `Accept-Language` header on outgoing API requests.
 *
 * The backend (I18nExceptionFilter, and any request-scoped i18n) reads this
 * header to translate error messages and responses into the user's language.
 *
 * Single source of truth for the storage key is i18n.ts (LANG_STORAGE_KEY).
 */
import { LANG_STORAGE_KEY } from '../i18n/i18n';

const DEFAULT_LANG = 'en';

/** Read the persisted language code (falls back to 'en'). */
export function getCurrentLang(): string {
  try {
    return localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG;
  } catch {
    // localStorage blocked (privacy mode)
    return DEFAULT_LANG;
  }
}

/**
 * Mutate an axios-style headers object in place to include Accept-Language.
 * Accepts the loose header shapes used across the various axios instances.
 */
export function attachLangHeader(
  headers: Record<string, unknown> | undefined,
): Record<string, unknown> {
  const h = headers ?? {};
  h['Accept-Language'] = getCurrentLang();
  return h;
}
